import {uuid} from '../util/random'

export default class ReactModel<T extends object> {
    id!: NullablePhpId
    key!: string

    constructor(data: Override<T,{id?: NullablePhpId},'key'>) {
        Object.assign(this, {
            id: null,
            ...data,
            key: uuid(),
        });
    }

    // shallowClone() {
    //     return new this.constructor({id: null});
    // }
}
